import React from 'react'
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

const styles = (theme: Theme) => ({
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  fabRoot: {
    width: '100%'
  }
});

interface Props {
  handleStartRecord: () => void;
  sourceSelected: number;
  isAudioAllowed: boolean;
  isVideoAllowed: boolean
}

interface State {
}

type PropsWithStyles = Props & WithStyles<'extendedIcon' | 'fabRoot'>;

class RecordButton extends React.Component<PropsWithStyles, State> {

  render() {
    const { classes } = this.props;

    return (  
        <Fab 
          color="primary"
          classes={{
            root: classes.fabRoot
          }}
          variant="extended" 
          size="large" 
          id="record-button"
          onClick={() => this.props.handleStartRecord()}
          disabled={!this.props.isVideoAllowed && this.props.sourceSelected === 1}
        >
          <FiberManualRecordIcon className={classes.extendedIcon} />  Start Recording
        </Fab>
    );
  }

  }

export default withStyles(styles)(RecordButton);  